import React from 'react';
import { Phone, Facebook, Instagram, Music2, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const FloatingWidgets = () => {
  return (
    <>
      {/* Floating Action Buttons - Right Side - SIMPLIFIÉ */}
      <div className="fixed right-6 bottom-6 z-[9999] flex flex-col items-end space-y-3">
        
        {/* Social Media Icons - Always Visible */}
        {/* Facebook */}
        <a
          href={companyInfo.social.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center shadow-2xl hover:bg-blue-700 transition-all transform hover:scale-110 group"
          aria-label="Facebook"
        >
          <Facebook size={24} />
        </a>

        {/* Instagram */}
        <a
          href={companyInfo.social.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-gradient-to-br from-purple-600 to-pink-600 text-white rounded-full flex items-center justify-center shadow-2xl hover:from-purple-700 hover:to-pink-700 transition-all transform hover:scale-110 group"
          aria-label="Instagram"
        >
          <Instagram size={24} />
        </a>

        {/* TikTok */}
        <a
          href={companyInfo.social.tiktok}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-black text-white rounded-full flex items-center justify-center shadow-2xl hover:bg-gray-800 transition-all transform hover:scale-110 group"
          aria-label="TikTok"
        >
          <Music2 size={24} />
        </a>

        {/* WhatsApp */}
        <a
          href={companyInfo.whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 text-white rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all transform hover:scale-110 group"
          aria-label="WhatsApp"
        >
          <MessageCircle size={24} />
        </a>

        {/* Call Button - UNIQUE et CLIGNOTANT */}
        <div className="relative">
          {/* Cercles de pulsation */}
          <span className="absolute inset-0 rounded-full bg-orange-400 animate-ping"></span>
          <span className="absolute inset-0 rounded-full bg-orange-300 animate-pulse opacity-75"></span>
          
          <a
            href={`tel:${companyInfo.phoneFormatted}`}
            className="relative w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full flex items-center justify-center shadow-2xl hover:from-orange-600 hover:to-orange-700 transition-all transform hover:scale-110 border-4 border-white"
            aria-label="Appeler"
          >
            <Phone size={32} className="relative z-10 animate-pulse" strokeWidth={3} />
          </a>
        </div>
      </div>
    </>
  );
};
